import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var ApiUrl = /*#__PURE__*/function () {
  function ApiUrl() {
    _classCallCheck(this, ApiUrl);
  }
  _createClass(ApiUrl, null, [{
    key: "webapiurl",
    value:
    /**
     * ApiUrl() gives the endpoint for the web api
     */
    function webapiurl() {
      switch (window.location.host) {
        case 'agrovertrouwen.wecr.wur.nl':
          return 'https://agrovertrouwen.wecr.wur.nl/WebApi';
        case 'acc.agrovertrouwen.wecr.wur.nl':
          return 'https://acc.agrovertrouwen.wecr.wur.nl/WebApi';
        case 'tst.agrovertrouwen.wecr.wur.nl':
          return 'https://tst.agrovertrouwen.wecr.wur.nl/WebApi';
        case 'agrovertrouwen.wser.wur.nl':
          return 'https://agrovertrouwen.wser.wur.nl/WebApi';
        case 'acc.agrovertrouwen.wser.wur.nl':
          return 'https://acc.agrovertrouwen.wser.wur.nl/WebApi';
        case 'tst.agrovertrouwen.wser.wur.nl':
          return 'https://tst.agrovertrouwen.wser.wur.nl/WebApi';
        default:
          return 'https://localhost:44314';
      }
    }
  }]);
  return ApiUrl;
}();